import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/home_header.jpg";
import SEO from "../designSystem/SEO";
import LightOutlinedButton from "../designSystem/buttons/LightOutlinedButton";
import LineLinkButton from "../designSystem/buttons/LineLinkButton";
import InvestmentImage1 from "../../assets/images/investment_image_001.jpg";
import InvestmentImage2 from "../../assets/images/investment_image_002.jpg";
import FAQ from "../designSystem/FAQ";
import { scrollToContact } from "../utils/navigation";

const InvestmentsPage = () => {
  return (
    <div>
      <SEO
        title="Investment Advice"
        description="Explore investment options, risk and long-term financial goals with personal investment advice from Monk Financial Planning."
        path="/investments"
      />
      <Hero
        //         title={`Financial Clarity
        // Direction & Confidence`}
        //         subtitle="Wealth Management Solutions"
        showOverlay={true}
        // backgroundImage={HeroBackground}
        titleAlign="center"
        subtitleAlign="center"
        pageTitle="investments"
        title="investment Advice"
        subtitle="Investing can help you work towards longer-term financial goals and make the most of your money over time. We can help you understand your investment options and how they could work alongside your pension and wider financial plan. Whether you’re investing for a specific goal or looking to build your long-term wealth, we can help you understand the options available to you."
        showButton={true}
        textAlign="center"
      ></Hero>

      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-reverse row-ratio-47-63">
          <div className="column gap-l">
            <LineLinkButton children="investments" />
            <h4 className="text-gray-3 uppercase">
              Make Your Wealth Work for You
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                Investing can form an important part of your wider financial
                plan, particularly when you are working towards longer-term
                goals. We can help you understand your investment options and
                how different approaches could fit with your financial
                circumstances, objectives and plans for the future.
              </div>
              <div className="content text-gray-3">
                The right approach will depend on factors such as your goals,
                timeframe, attitude to risk and individual circumstances. We’ll
                help you understand the potential risks and opportunities, so
                you can make more informed decisions about your money.
              </div>
            </div>
          </div>
          <img src={InvestmentImage1} alt="Client reviewing long-term investment plans" className="image-cover" />
        </div>
      </div>
      <div className="background-container bg-gray-3 ">
        <div className="content-container column align-center gap-l py-xxl px-xxxl">
          <LineLinkButton children="investments" />
          <h4 className="uppercase text-primary-1">How we can help</h4>
          <FAQ
            items={[
              {
                question: "Investing for Your Future",
                answer:
                  "Keeping money in cash can be appropriate for some goals and circumstances, while investing may provide an opportunity for longer-term growth. We can help you understand how investing could fit into your plans and the potential risks and opportunities involved.",
              },
              {
                question: "Understanding Investment Risk",
                answer:
                  "Investments can fall as well as rise in value, and you may get back less than you invest. We can help you understand the level of risk involved and consider how this fits with your goals, timeframe and wider financial circumstances.",
              },
              {
                question: "Investments and Pensions",
                answer:
                  "Your pension does not necessarily have to be your only long-term investment, and other investments may provide additional flexibility. We can help you consider how your investments and pension could work together as part of your wider financial plan.",
              },
              {
                question: "Long-Term Financial Goals",
                answer:
                  "Your investment strategy should reflect what you are hoping to achieve and when you may need access to your money. We can help you consider your longer-term goals and understand how different investment options could support your plans.",
              },
            ]}
          />
        </div>
      </div>
      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-ratio-47-63">
          <img src={InvestmentImage2} alt="Financial adviser explaining investment options" className="image-cover" />{" "}
          <div className="column gap-l">
            <LineLinkButton children="Investments" />
            <h4 className="text-gray-3 uppercase">
              Looking at the Bigger Picture
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                Investments can form one part of a wider financial plan,
                alongside your pension, savings and other financial
                arrangements. Taking these areas into account can help you build
                a clearer picture of how your money could support your goals
                over the longer term.
              </div>
              <div className="content text-gray-3">
                We can help you consider your investments alongside your wider
                financial circumstances, taking into account your objectives,
                timeframe and attitude to risk. By looking at the bigger
                picture, we can help you understand how your investments could
                work towards your financial goals and future plans.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1 ">
        <div className="content-container py-xxl px-xxxl column gap-l align-center">
          <LineLinkButton onClick={scrollToContact} children="Contact Us" />
          <h4 className=" text-gray-3 uppercase">Ready to talk?</h4>
          <div className="content text-gray-3">
            We can help you consider how pensions and investments could work
            together as part of your financial plan.
          </div>
          <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
        </div>
      </div>
    </div>
  );
};

export default InvestmentsPage;
